import { useStyletron } from 'baseui'

const useContractsTableStyles = () => {
  const [css, theme] = useStyletron()

  const headCellOverrides = {
    HeadCell: {
      style: {
        padding: '0',
        backgroundColor: theme.colors.backgroundSecondary,
      },
    },
    SortableLabel: {
      style: {
        padding: '.5rem',
        width: '100%',
        fontSize: '12px',
        color: theme.colors.contentPrimary,
      },
    },
  }

  const loadingStyle = css({
    height: '500px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  })

  const tableHeight = css({ height: '500px' })

  const tableRow = css({
    display: 'contents',
  })

  const headingDisplay = css({ display: 'contents' })

  const cellStyle = css({
    padding: '.5rem',
    fontSize: '13px',
  })

  const emptyStateStyle = css({
    gridColumn: '1 / -1',
    padding: '2rem',
    textAlign: 'center' as const,
    color: theme.colors.contentSecondary,
  })

  return {
    headCellOverrides,
    loadingStyle,
    tableHeight,
    tableRow,
    headingDisplay,
    cellStyle,
    emptyStateStyle,
  }
}

export default useContractsTableStyles
